import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const WhatsappFlowsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp_flows'),
      name: 'whatsapp_flows_list',
      meta: {
        permissions: ['administrator', 'agent'],
        featureFlag: FEATURE_FLAGS.WHATSAPP_FLOWS,
      },
      component: () => import('./Index.vue'),
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp_flows/:flowId/edit'),
      name: 'whatsapp_flow_edit',
      meta: {
        permissions: ['administrator', 'agent'],
        featureFlag: FEATURE_FLAGS.WHATSAPP_FLOWS,
      },
      component: () => import('./Edit.vue'),
    },
  ],
};

export default WhatsappFlowsRoutes;

